(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.EditCompanyLineupsController = (function(superClass) {
    extend(EditCompanyLineupsController, superClass);

    function EditCompanyLineupsController(scope, transitions, modal, modalInstance, service, company, lineups, crops, seedCompanies) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.modalInstance = modalInstance;
      this.service = service;
      this.company = company;
      this.save = bind(this.save, this);
      this.toggleSeedCompany = bind(this.toggleSeedCompany, this);
      this.seedCompanyIsEnabled = bind(this.seedCompanyIsEnabled, this);
      this.addNewSeedCompany = bind(this.addNewSeedCompany, this);
      this.selectCrop = bind(this.selectCrop, this);
      this.toggleCrop = bind(this.toggleCrop, this);
      this.cropIsEnabled = bind(this.cropIsEnabled, this);
      EditCompanyLineupsController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.absolute_errors = true;
      this.scope.title = "Edit " + this.company.name + " Lineups";
      this.scope.lineups = lineups.data;
      this.scope.crops = crops.data;
      this.scope.seedCompanies = seedCompanies.data;
      this.scope.selectedCrop = null;
      this.scope.cropIsEnabled = this.cropIsEnabled;
      this.scope.toggleCrop = this.toggleCrop;
      this.scope.selectCrop = this.selectCrop;
      this.scope.addNewSeedCompany = this.addNewSeedCompany;
      this.scope.seedCompanyIsEnabled = this.seedCompanyIsEnabled;
      this.scope.toggleSeedCompany = this.toggleSeedCompany;
      this.savedSeedCompanies = [];
    }

    EditCompanyLineupsController.prototype.cropIsEnabled = function(crop) {
      var j, len, lineup, ref;
      ref = this.scope.lineups;
      for (j = 0, len = ref.length; j < len; j++) {
        lineup = ref[j];
        if (lineup.crop.id === crop.id) {
          return true;
        }
      }
      return false;
    };

    EditCompanyLineupsController.prototype.toggleCrop = function(crop) {
      var i, j, len, lineup, ref, ref1;
      ref = this.scope.lineups;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        lineup = ref[i];
        if (lineup.crop.id === crop.id) {
          this.savedSeedCompanies[crop.id] = lineup.seed_companies;
          this.scope.lineups.splice(i, 1);
          if (crop.id === ((ref1 = this.scope.selectedCrop) != null ? ref1.id : void 0)) {
            this.scope.selectedCrop = null;
          }
          return;
        }
      }
      return this.scope.lineups.push({
        crop: crop,
        seed_companies: this.savedSeedCompanies[crop.id] || []
      });
    };

    EditCompanyLineupsController.prototype.selectCrop = function(crop) {
      if (!this.cropIsEnabled(crop)) {
        return;
      }
      return this.scope.selectedCrop = crop;
    };

    EditCompanyLineupsController.prototype.addNewSeedCompany = function() {
      var dialog;
      dialog = this.modal.open({
        windowClass: 'small_dialog',
        templateUrl: 'backend/admin/new-tools/companies/ng-seed-company-dialog',
        controller: 'Tools.Controllers.SeedCompanyDialogController'
      });
      return dialog.result.then((function(_this) {
        return function(saved_seed_company) {
          return _this.scope.seedCompanies.push(saved_seed_company);
        };
      })(this));
    };

    EditCompanyLineupsController.prototype.seedCompanyIsEnabled = function(seedCompany) {
      var j, k, len, len1, lineup, lineupSeedCompany, ref, ref1;
      ref = this.scope.lineups;
      for (j = 0, len = ref.length; j < len; j++) {
        lineup = ref[j];
        if (lineup.crop.id !== this.scope.selectedCrop.id) {
          continue;
        }
        ref1 = lineup.seed_companies;
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          lineupSeedCompany = ref1[k];
          if (lineupSeedCompany.id === seedCompany.id) {
            return true;
          }
        }
        return false;
      }
    };

    EditCompanyLineupsController.prototype.toggleSeedCompany = function(seedCompany) {
      var i, j, k, len, len1, lineup, lineupSeedCompany, ref, ref1;
      ref = this.scope.lineups;
      for (j = 0, len = ref.length; j < len; j++) {
        lineup = ref[j];
        if (lineup.crop.id === this.scope.selectedCrop.id) {
          ref1 = lineup.seed_companies;
          for (i = k = 0, len1 = ref1.length; k < len1; i = ++k) {
            lineupSeedCompany = ref1[i];
            if (lineupSeedCompany.id === seedCompany.id) {
              lineup.seed_companies.splice(i, 1);
              return;
            }
          }
          lineup.seed_companies.push(seedCompany);
          return;
        }
      }
    };

    EditCompanyLineupsController.prototype.save = function() {
      return this.service.saveCompanyLineups(this.company.id, this.scope.lineups).then((function(_this) {
        return function(response) {
          return _this.closeWithAlert(response.data.status);
        };
      })(this));
    };

    return EditCompanyLineupsController;

  })(DialogController);

}).call(this);
